export default __webpack_public_path__ + "/static/media/jobhunter-common-web/icon_close.36e6b250ced95f5dd59c33e5287d9a8c.png";